<unity-dropdown-control
  [displayName]="$displayName()"
  [description]="$description()"
  [values]="$workflows()"
  [valuePrimitive]="true"
  [control]="$control()"
  [defaultItem]="$defaultItem()"
  [showHint]="$showHint()"
  (selectionChange)="onSelectionChange($event)" />
